export default __webpack_public_path__ + "static/media/header_open.f587da2d.svg";